import { Component, Input, AfterViewInit, EventEmitter, Output } from '@angular/core';
import * as firebase from 'firebase';
import { MemberService } from './member.service';
import { Member } from './member';
import * as _ from 'underscore';

import tinymce from 'tinymce/tinymce';
import 'tinymce/themes/modern/theme';
import 'tinymce/plugins/paste';
import 'tinymce/plugins/link';
import 'tinymce/plugins/textcolor';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/emoticons';
import 'tinymce/plugins/table';
import 'tinymce/plugins/image';
import 'tinymce/plugins/media';
import 'tinymce/plugins/imagetools';

@Component({
  selector: 'cef-dashboard',
  templateUrl: './dashboard.component.html'
})

export class DashboardComponent implements AfterViewInit {
	@Output() onEditorKeyup = new EventEmitter<any>();
	userEmail:string
	memberProfile;
	memberMsg=[];
	warningMsg='';
	
	public unitQuery = "";
	public allUsers;
	public rankList = [];
	public rankSortBy = "score";
	public rankSortOrder = "desc";
	public rowsOnPage = 10;
	taskAwards
	message = {title:'', replyTitle:'',body:'', type:'', sendFrom:'', sendTo:[], replyContent:''};

	editor;
	avatar = [0,0,0,0];
	constructor(private memberService: MemberService) {	
		firebase.auth().onAuthStateChanged(user => {
			if (user) {
				//this.userEmail = user.email;
				let db = firebase.database();
			    db.ref('profile/'+user.uid).once('value').then(
					(snapshot:any) => {
						if (snapshot.val()){
							this.memberProfile = snapshot.val();
							this.memberProfile.Uid = user.uid;
							//this.memberService.getAwards(this.memberProfile.Uid).subscribe(
							//	(awards:any)=>{
							//		this.taskAwards = awards;
							//		this.memberService.genCert(this.memberProfile, this.taskAwards);
							//	}
							//)

							this.memberProfile.email = user.email;
							if (this.memberProfile.level==4){
								db.ref('childToParent/4/'+user.uid).once('value').then(
									(teacher:any) =>{
										if (teacher.val()){
											this.memberProfile.tutorUid = teacher.val();
											db.ref('profile/'+this.memberProfile.tutorUid).once('value').then(
												(tutorName:any) =>{
													if (tutorName.val()){
														this.memberProfile.tutorName = tutorName.val().name;
														this.memberService.getAwards(this.memberProfile).subscribe(
															(awards:any)=>{
																this.taskAwards = awards;
																//console.log(this.taskAwards);
															}
														)
													}
													
												}
											)
										}
									}
								)
							}
							
							if (this.memberProfile.avatar){
								this.avatar=this.memberProfile.avatar;
							}
							this.memberService.avatar().subscribe(
								(avatar:any)=>{
									this.avatar = avatar;
									console.log(this.avatar)
								}
							)

							//this.memberService.getCert(this.memberProfile);
						}				
					}
				)
				this._updateMsg(user.uid);
				
			}
		})
	}
	
	_updateMsg(userUid:string){
		this.memberMsg = [];
		let db = firebase.database();
		db.ref('memberMsg/'+userUid).once('value').then(
			(snapshot:any) => {
				if (snapshot.val()){
					var allMsg = snapshot.val();
					var index = 0;
					if (allMsg['in']){
						for(let msgId in allMsg['in']){
							this.memberMsg.push(allMsg['in'][msgId]);
							this.memberMsg[index].id = msgId;
							this.memberMsg[index].type = 'in';
							this.memberMsg[index].read = allMsg['in'][msgId].read;
							//console.log(allMsg['in'][msgId]);
							index++;
						}
					}
					if (allMsg['out']){
						for(let msgId in allMsg['out']){
							this.memberMsg.push(allMsg['out'][msgId]);
							this.memberMsg[index].id = msgId;
							this.memberMsg[index].type = 'out';
							index++;
						}
					}
					//this.memberMsg = _.sortBy( this.memberMsg, 'sendDate' );
					this.memberMsg = _.sortBy( this.memberMsg,
						function (item) {                        
                       		return new Date(item.sendDate).getTime()*-1;
                    } );
				}
			}
		)
	}

	ngAfterViewInit() {
		tinymce.init({
		  selector: '#msgEditor',
		  plugins: ['link', 'paste', 'textcolor', 'autolink', 'emoticons', 'table','image', 'media', 'imagetools'],
		  skin_url: '../assets/skins/lightgray',
		  toolbar1: 'undo redo styleselect bold italic alignleft aligncenter alignright bullist numlist outdent indent code',
		  toolbar2: 'emoticons image media link paste forecolor backcolor',
		  paste_data_images: false, 
		  min_height: 200, 
		  setup: editor => {
		    this.editor = editor;
		    editor.on('keyup', () => {
		      const content = editor.getContent();
		      this.onEditorKeyup.emit(content);
		    });
		  },
		});
	}

	hallOfFrame(){
		this.rankList = []
		var db = firebase.database();
		db.ref('profile').once('value').then(
			(allUsers:any) => {
				this.allUsers = allUsers.val()
				db.ref('awards').once('value').then(
					(awards:any) => {
						var updatedAwards = awards.val()
						for (var uid in updatedAwards){
							var retTaskAwards = {
								uid:uid,
								name:'',
								unit:'',
								score:0,
								progress:{
									newMember:[],
									journey:{},
									joy:{}
								},
								awards:{
									login:0,
									journey:0,
									joy:0,
									newMember:false
								}
							}
							
							retTaskAwards.name = this.allUsers[uid].name;
							retTaskAwards.unit = this.allUsers[uid].unit;
		
							if (updatedAwards[uid].login) {
								//retTaskAwards.progress.newMember.push('login');
								retTaskAwards.awards.login = updatedAwards[uid].login.length-1;
								retTaskAwards.score += updatedAwards[uid].login.length-1
							}
							//if (updatedAwards[uid].updateProfile) retTaskAwards.progress.newMember.push('updateProfile');
							//if (updatedAwards[uid].viewWebGuide) retTaskAwards.progress.newMember.push('viewWebGuide');
							//if (updatedAwards[uid].viewSpritJoyGuide) retTaskAwards.progress.newMember.push('viewWebGuide');
							if (retTaskAwards.progress.newMember.length==4) {
								retTaskAwards.awards.newMember = true;
								retTaskAwards.score += 1
							}
							
							//check other awards
							if (updatedAwards[uid].readJourney) {
								retTaskAwards.awards.journey = updatedAwards[uid].readJourney.length-1;
								retTaskAwards.score += retTaskAwards.awards.journey
							}
							if (updatedAwards[uid].readSpritJoy) {
								retTaskAwards.awards.joy = updatedAwards[uid].readSpritJoy.length-1;
								retTaskAwards.score += retTaskAwards.awards.joy
							}
							this.rankList.push(retTaskAwards);
						}
						//console.log(this.rankList)
					}
				)
			}
		)
		
	}

	showMsg(contentId:string, msgId:string, msgIndex, msgType:string) {
		this.message.title = this.memberMsg[msgIndex].title;
		this.message.replyTitle = '回覆：'+this.message.title;
		this.message.sendFrom = this.memberMsg[msgIndex].sendFrom;
		let db = firebase.database();
		db.ref('message/'+contentId).once('value').then(
			(snapshot:any) => {
				this.message.body = snapshot.val().content;
				if (msgType=='in'){
					db.ref('memberMsg/'+this.memberProfile.Uid+'/in/'+msgId+'/read').set((new Date()).toString()).then(
						(val:any)=>{
							console.log(msgId);
							this.memberMsg[msgIndex].read = new Date().toString();
						}
					)
				}
			}
		)
	}

	confirmReply(){
		this.message.replyContent = tinymce.activeEditor.getContent();
		
		let db = firebase.database();
		db.ref('message/').push({content:this.message.replyContent}).then(
			(val:any)=>{
				var contentUid = val.key;
				db.ref('memberMsg/'+this.memberProfile.Uid+'/out').push(
					{
						title:this.message.replyTitle,
						type:'栽培回應',
						contentId:contentUid,
						sendDate:(new Date()).toString(),
						sendTo:[this.message.sendFrom]
					}
				).then(
					(val:any) => {
						db.ref('memberMsg/'+this.message.sendFrom+'/in').push(
							{
								title:this.message.replyTitle,
								type:'栽培回應',
								contentId:contentUid,
								sendDate:(new Date()).toString(),
								sendFrom:this.memberProfile.Uid
							}
						)
						this.warningMsg = '訊息已發送！';
						this._updateMsg(this.memberProfile.Uid);
						setTimeout(()=>{
							this.message = {title:'', replyTitle:'',body:'', type:'', sendFrom:'', sendTo:[], replyContent:''};
						},this.memberService.modalDismiss);
					}
					
				)
			}
		)
	}
}



// WEBPACK FOOTER //
// C:/Users/noomo/Desktop/project/newCefKid/cefapp2/src/app/member/dashboard.component.ts